import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import './footer.css';
import logo from '../../assets/logo.png' // Atualize com o caminho correto

function AppFooter() {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer id="footer">
      <Container>
        <Row className="footer-main">
          <Col lg={4} md={6} className="footer-col logo-col">
            <div className="footer-logo">
              <img src={logo} alt="Logo Corporativo" className="logo-img" />
            </div>
              <p className="logo-description">No Instituto Superior Politécnico Atlântida, a excelência acadêmica se une à inovação para criar oportunidades reais. Seu potencial merece um lugar à frente do amanhã.</p>
            <div className="footer-socials">
              <a href="https://www.facebook.com/ispatlantida24" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/isp_atlantida/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </Col>
          
          <Col lg={4} md={6} className="footer-col links-col">
            <Row>
              <Col sm={6}>
                <h5>Links Rápidos</h5>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/sobre">Sobre</Link></li>
                  <li><Link to="/servicos">Serviços</Link></li>
                  <li><Link to="/missao">Nossa Missão, Visão e Valores</Link></li>
                  <li><Link to="/faq">Perguntas Frequentes</Link></li>
                </ul>
              </Col>
              <Col sm={6}>
                <h5>Serviços</h5>
                <ul>
                  <li><Link to="/comunicacao/noticias">Noticias</Link></li>
                  <li><Link to="/comunicacao/eventos">Eventos</Link></li>
                  <li><Link to="/programas/unidade-organica">Unidade orgânica</Link></li>
                  <li><Link to="/investigacao/jornada">Jornada Científica</Link></li>
                </ul>
              </Col>
            </Row>
          </Col>
          
          <Col lg={4} md={12} className="footer-col contact-col">
            <h5>Contato</h5>
            <ul className="contact-info">
              <li><i className="fas fa-map-marker-alt"></i>Benfica, Estrada Lar do Patriota, Junto a Rua 14, Luanda, Angola</li>
              <li><i className="fas fa-phone"></i> (+244) 929 282 704</li>
              <li><i className="fas fa-envelope"></i>secretariageral@ispatlantida.co.ao</li>
              <li><i className="fas fa-clock"></i> Seg-Sex: 9h às 18h</li>
            </ul>
          </Col>
        </Row>
        
        <Row className="footer-bottom">
          <Col>
            <div className="footer-legal">
              <p>&copy; {new Date().getFullYear()} Corporativo. Todos os direitos reservados.</p>
            </div>
          </Col>
        </Row>
      </Container>
      
      {showTopBtn && (
        <button className="go-top-btn" onClick={goTop} title="Voltar ao topo">
          <i className="fas fa-arrow-up"></i>
        </button>
      )}
    </footer>
  );
}

export default AppFooter;